import AbstractController from "../../../../../vendors/services/abstractController";
import { useState } from "react";
import ContribuicaoService from "../../../../services/contribuicao.service";

export default class ContribuicaoPublicadaController extends AbstractController {
  public service: ContribuicaoService;

  public listaGeral: any;
  public setListaGeral: any;

  public lista: any;
  public setLista: any;

  public filter: any;
  public setFilter: any;

  constructor() {
    super();
    [this.lista, this.setLista] = useState([]);
    [this.listaGeral, this.setListaGeral] = useState([]);
    [this.filter, this.setFilter] = useState("");
    this.service = new ContribuicaoService();
  }

  async obterContribuicoesPublicadas(codigoAudienciaPublica: any) {
    this.start();
    try {
      const res: any = await this.service.getContribuicoesPublicadas(
        codigoAudienciaPublica,
        this.getCodContribuinte()
      );
      if (!!res.result && res.result.length > 0) {
        this.setListaGeral([...res.result]);
        this.setLista([...res.result]);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      this.stop();
    }
  }

  filtrarDispositivos() {
    const _filter = this.filter.toLowerCase().trim();
    if (!_filter || _filter.length === 0) {
      this.setLista([...this.listaGeral]);
      return;
    }
    let _lista = [...this.listaGeral];
    _lista = _lista.filter((dispositivo) =>
      dispositivo.contribuicao.some(
        (contribuicao: any) =>
          contribuicao.dsContribuicao &&
          contribuicao.dsContribuicao.toLowerCase().includes(_filter)
      )
    );
    this.setLista(_lista);
  }
}
